(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5405],{

/***/ 8773:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ZP": function() { return /* binding */ esm_card; }
});

// UNUSED EXPORTS: StyledCard, StyledCardBody, StyledCardFooter, StyledCardHeader

// EXTERNAL MODULE: ./node_modules/@nextui-org/react/esm/image/index.js + 3 modules
var esm_image = __webpack_require__(74259);
// EXTERNAL MODULE: ./node_modules/@nextui-org/react/esm/divider/index.js + 2 modules
var divider = __webpack_require__(16221);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@nextui-org/react/esm/utils/drip.js
var drip = __webpack_require__(8375);
// EXTERNAL MODULE: ./node_modules/@nextui-org/react/esm/utils/assertion.js
var assertion = __webpack_require__(3569);
// EXTERNAL MODULE: ./node_modules/@nextui-org/react/node_modules/@react-aria/focus/dist/module.js + 2 modules
var dist_module = __webpack_require__(18878);
// EXTERNAL MODULE: ./node_modules/@nextui-org/react/node_modules/@react-aria/utils/dist/module.js
var utils_dist_module = __webpack_require__(92317);
// EXTERNAL MODULE: ./node_modules/@nextui-org/react/node_modules/@react-aria/interactions/dist/module.js + 1 modules
var interactions_dist_module = __webpack_require__(38990);
// EXTERNAL MODULE: ./node_modules/@nextui-org/react/esm/use-drip/index.js + 1 modules
var use_drip = __webpack_require__(69260);
// EXTERNAL MODULE: ./node_modules/@nextui-org/react/esm/utils/dom.js
var dom = __webpack_require__(72903);
;// CONCATENATED MODULE: ./node_modules/@nextui-org/react/esm/card/use-card.js
const useCard=l=>{const{ref:n,disableAnimation:c=!1,disableRipple:p=!1,variant:d="shadow",isHoverable:u=!1,borderWeight:m="light",isPressable:b=!1,onClick:P,onPress:f,autoFocus:v,allowTextSelectionOnPress:C=!0,...g}=l,h=(0,dom/* useDOMRef */.gy)(n),{onClick:k,...F}=(0,use_drip/* default */.Z)(!1,h),H=r=>{c||p||!h.current||k(r)},{isPressed:T,pressProps:w}=(0,interactions_dist_module/* usePress */.r7)({isDisabled:!b,onPress:r=>{"keyboard"!==r.pointerType&&"virtual"!==r.pointerType||(H(r),null==P||P(r)),null==f||f(r)},allowTextSelectionOnPress:C,...g}),{hoverProps:x,isHovered:y}=(0,interactions_dist_module/* useHover */.XI)({isDisabled:!u,...g}),{isFocusVisible:D,focusProps:R}=(0,dist_module/* useFocusRing */.Fx)({autoFocus:v});w.onClick=r=>{b&&(H(r),null==P||P(r))};const A=(0,react.useCallback)(((r={})=>({...(0,utils_dist_module/* mergeProps */.dG)(b?{...w,...R}:{},u?x:{},g,r)})),[b,u,w,R,x,g]);return{cardRef:h,variant:d,borderWeight:m,isPressable:b,isHovered:y,isPressed:T,disableAnimation:c,disableRipple:p,dripBindings:F,onDripClickHandler:k,isFocusVisible:D,getCardProps:A}};
// EXTERNAL MODULE: ./node_modules/@nextui-org/react/esm/theme/stitches.config.js + 1 modules
var stitches_config = __webpack_require__(86212);
// EXTERNAL MODULE: ./node_modules/@nextui-org/react/esm/theme/shared-css.js
var shared_css = __webpack_require__(39975);
;// CONCATENATED MODULE: ./node_modules/@nextui-org/react/esm/card/card.styles.js
const StyledCardBody=(0,stitches_config/* styled */.zo)("div",{d:"flex",w:"100%",h:"auto",flex:"1 1 auto",fd:"column",jc:"inherit",ai:"inherit",ac:"inherit",py:"$lg",px:"$sm",oy:"auto",position:"relative",ta:"left"});const StyledCard=(0,stitches_config/* styled */.zo)("div",{$$cardColor:"$colors$backgroundContrast",$$cardTextColor:"$colors$text",m:0,p:0,br:"$lg",bg:"$$cardColor",color:"$$cardTextColor",position:"relative",display:"flex",overflow:"hidden",fd:"column",width:"100%",height:"auto",boxSizing:"border-box","@motion":{transition:"none"},".nextui-image":{width:"100%"},[`& ${drip/* StyledDrip */.q}`]:{zIndex:"$1",".nextui-drip-filler":{opacity:.25,fill:"$accents6"}},variants:{variant:{flat:{bg:"$accents0"},shadow:{dropShadow:"$lg","@safari":{boxShadow:"$lg",dropShadow:"none"}},bordered:{borderStyle:"solid",borderColor:"$border"}},borderWeight:{light:{bw:"$light"},normal:{bw:"$normal"},bold:{bw:"$bold"},extrabold:{bw:"$extrabold"},black:{bw:"$black"}},disableAnimation:{true:{transition:"none"},false:{transition:"$card"}},isPressable:{true:{cursor:"pointer",us:"none",WebkitTapHighlightColor:"transparent"}},isPressed:{true:{}},isHovered:{true:{dropShadow:"$lg","@safari":{boxShadow:"$lg",dropShadow:"none"}}}},compoundVariants:[{isPressed:!0,disableAnimation:!1,css:{transform:"scale(0.97)"}},{isHovered:!0,disableAnimation:!1,css:{transform:"translateY(-2px)"}},{isHovered:!0,variant:"shadow",css:{dropShadow:"$xl","@safari":{boxShadow:"$xl",dropShadow:"none"}}}]},shared_css/* cssNoBlurriness */.UU,shared_css/* cssFocusVisible */.BM);const StyledCardHeader=(0,stitches_config/* styled */.zo)("div",{w:"100%",display:"flex",flexShrink:0,zIndex:"$1",jc:"flex-start",ai:"center",overflow:"hidden",color:"inherit",p:"$sm"});const StyledCardFooter=(0,stitches_config/* styled */.zo)("div",{w:"100%",h:"auto",p:"$sm",d:"flex",ai:"center",overflow:"hidden",color:"inherit",bblr:"$lg",bbrr:"$lg",variants:{isBlurred:{true:{bf:"saturate(180%) blur(10px)",bg:"$$cardColor"}}}});
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./node_modules/@nextui-org/react/esm/card/card.js
const d=react.forwardRef((({...r},e)=>{const{as:d,css:n,children:m,...c}=r,{cardRef:l,variant:p,isFocusVisible:f,isPressable:b,isPressed:u,disableAnimation:x,disableRipple:g,borderWeight:P,isHovered:h,getCardProps:j,dripBindings:v}=useCard({...c,ref:e});return (0,jsx_runtime.jsxs)(StyledCard,{ref:l,as:d,borderWeight:P,css:n,disableAnimation:x,isFocusVisible:f,isHovered:h,isPressable:b,isPressed:u,role:b?"button":"section",tabIndex:b?0:-1,variant:p,...j(),children:[b&&!x&&!g&&(0,jsx_runtime.jsx)(drip/* default */.Z,{...v}),m]})}));assertion/* __DEV__ */.Ts&&(d.displayName="NextUI.Card"),d.toString=()=>".nextui-card";/* harmony default export */ var card = (d);
;// CONCATENATED MODULE: ./node_modules/@nextui-org/react/esm/card/index.js
card.Header=StyledCardHeader,card.Body=StyledCardBody,card.Footer=StyledCardFooter,card.Image=esm_image/* default */.ZP,card.Divider=divider/* default */.ZP;/* harmony default export */ var esm_card = (card);

/***/ }),

/***/ 22553:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ZP": function() { return /* binding */ esm_grid; }
});

// UNUSED EXPORTS: StyledGridContainer, StyledGridItem

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@nextui-org/react/esm/utils/clsx.js
var clsx = __webpack_require__(61309);
// EXTERNAL MODULE: ./node_modules/@nextui-org/react/esm/utils/with-defaults.js
var with_defaults = __webpack_require__(50088);
// EXTERNAL MODULE: ./node_modules/@nextui-org/react/esm/theme/stitches.config.js + 1 modules
var stitches_config = __webpack_require__(86212);
;// CONCATENATED MODULE: ./node_modules/@nextui-org/react/esm/grid/grid.styles.js
const StyledGridContainer=(0,stitches_config/* styled */.zo)("div",{});const StyledGridItem=(0,stitches_config/* styled */.zo)("div",{margin:0,boxSizing:"border-box",padding:"$$gridGapUnit"});
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./node_modules/@nextui-org/react/esm/grid/grid-item.js
const l=t=>{const s=0===t?"none":"inherit";if("number"==typeof t){const e=100/12*t,i=e>100?"100%":e<0?"0":`${e}%`;return{flexGrow:0,display:s,maxWidth:i,flexBasis:i}}return{flexGrow:1,display:s,maxWidth:"100%",flexBasis:"0"}},n=react.forwardRef((({xs:t,sm:i,md:n,lg:o,xl:x,css:a,justify:d,direction:c,alignItems:f,alignContent:u,children:g,className:p,...y},h)=>{const j=(0,react.useMemo)((()=>{const s={xs:t,sm:i,md:n,lg:o,xl:x};return Object.keys(s).reduce(((t,e)=>void 0!==s[e]&&!1!==s[e]?`${t} ${e}`:t),"").trim()}),[t,i,n,o,x]);return (0,jsx_runtime.jsx)(StyledGridItem,{ref:h,className:(0,clsx/* default */.Z)("nextui-grid-item",j,p),css:{alignItems:f,alignContent:u,justifyContent:d,flexDirection:c,"&.xs":{...l(t)},"@xsMax":{"&.xs":{...l(t)}},"@sm":{"&.sm":{...l(i)}},"@md":{"&.md":{...l(n)}},"@lg":{"&.lg":{...l(o)}},"@xl":{"&.xl":{...l(x)}},...a},...y,children:g})}));n.displayName="NextUI.GridItem",n.toString=()=>".nextui-grid-item";/* harmony default export */ var grid_item = ((0,with_defaults/* default */.Z)(n,{xs:!1,sm:!1,md:!1,lg:!1,xl:!1,className:""}));
;// CONCATENATED MODULE: ./node_modules/@nextui-org/react/esm/grid/grid.js
const i=react.forwardRef((({children:r,css:i,...o},m)=>(0,jsx_runtime.jsx)(grid_item,{ref:m,css:{...i},...o,children:r})));i.displayName="NextUI.Grid",i.toString=()=>".nextui-grid";/* harmony default export */ var grid = (i);
;// CONCATENATED MODULE: ./node_modules/@nextui-org/react/esm/grid/grid-container.js
const c=react.forwardRef((({gap:r,wrap:t,css:c,children:o,className:n,...p},l)=>{const m=(0,react.useMemo)((()=>`calc(${r} * $space$3)`),[r]);return (0,jsx_runtime.jsx)(grid_item,{ref:l,className:(0,clsx/* default */.Z)("nextui-grid-container",n),css:{$$gridGapUnit:m,display:"flex",flexWrap:t,boxSizing:"border-box",margin:"calc(-1 * $$gridGapUnit)",width:"calc(100% + $$gridGapUnit * 2)",...c},...p,children:o})}));c.displayName="NextUI.GridContainer",c.toString=()=>".nextui-grid-container";/* harmony default export */ var grid_container = ((0,with_defaults/* default */.Z)(c,{gap:0,wrap:"wrap",className:""}));
;// CONCATENATED MODULE: ./node_modules/@nextui-org/react/esm/grid/index.js
grid.Container=grid_container;/* harmony default export */ var esm_grid = (grid);

/***/ }),

/***/ 74259:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ZP": function() { return /* binding */ esm_image; }
});

// UNUSED EXPORTS: StyledImage, StyledImageContainer, StyledImageSkeleton

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@nextui-org/react/esm/use-real-shape/index.js + 1 modules
var use_real_shape = __webpack_require__(35366);
// EXTERNAL MODULE: ./node_modules/@nextui-org/react/esm/use-current-state/index.js + 1 modules
var use_current_state = __webpack_require__(66391);
// EXTERNAL MODULE: ./node_modules/@nextui-org/react/esm/use-resize/index.js + 1 modules
var use_resize = __webpack_require__(36693);
// EXTERNAL MODULE: ./node_modules/@nextui-org/react/esm/utils/dom.js
var dom = __webpack_require__(72903);
// EXTERNAL MODULE: ./node_modules/@nextui-org/react/esm/utils/assertion.js
var assertion = __webpack_require__(3569);
// EXTERNAL MODULE: ./node_modules/@nextui-org/react/esm/utils/clsx.js
var clsx = __webpack_require__(61309);
// EXTERNAL MODULE: ./node_modules/@nextui-org/react/esm/theme/stitches.config.js + 1 modules
var stitches_config = __webpack_require__(86212);
;// CONCATENATED MODULE: ./node_modules/@nextui-org/react/esm/image/image.styles.js
const i=(0,stitches_config/* keyframes */.F4)({"0%":{backgroundPosition:"200% 0"},to:{backgroundPosition:"-200% 0"}});const StyledImageContainer=(0,stitches_config/* styled */.zo)("div",{opacity:0,margin:"0 auto",position:"relative",overflow:"hidden",maxWidth:"100%",transition:"transform 250ms ease 0ms, opacity 200ms ease-in 0ms","@motion":{transition:"none"},variants:{ready:{true:{opacity:1},false:{opacity:0}}}});const StyledImage=(0,stitches_config/* styled */.zo)("img",{size:"100%",display:"block"});const StyledImageSkeleton=(0,stitches_config/* styled */.zo)("div",{position:"absolute",top:0,left:0,right:0,bottom:0,size:"100%",borderRadius:"inherit",backgroundImage:"linear-gradient(270deg, $colors$accents1, $colors$accents2, $colors$accents2, $colors$accents1)",backgroundSize:"400% 100%",animation:`${i} 5s ease-in-out infinite`,transition:"opacity 300ms ease-out"});
// EXTERNAL MODULE: ./node_modules/@nextui-org/react/esm/utils/with-defaults.js
var with_defaults = __webpack_require__(50088);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./node_modules/@nextui-org/react/esm/image/image.skeleton.js
const a=react.memo((({opacity:t,css:e,className:m,...a})=>(0,jsx_runtime.jsx)(StyledImageSkeleton,{className:(0,clsx/* default */.Z)("nextui-image-skeleton",m),css:{opacity:t,...e},...a})));assertion/* __DEV__ */.Ts&&(a.displayName="NextUI.ImageSkeleton"),a.toString=()=>".nextui-image-skeleton";/* harmony default export */ var image_skeleton = ((0,with_defaults/* default */.Z)(a,{opacity:.5,className:""}));
;// CONCATENATED MODULE: ./node_modules/@nextui-org/react/esm/image/image.js
const Image=react.forwardRef(((t,n)=>{const{src:g,width:h,height:x,showSkeleton:w=!0,className:y,maxDelay:j=3e3,autoResize:I=!1,objectFit:N="scale-down",containerCss:b,css:T,...$}=t,k=(0,dom/* useDOMRef */.gy)(n),[z,F]=(0,react.useState)(!0),[R,S]=(0,react.useState)(w),{w:C,h:D}=(0,react.useMemo)((()=>({w:h?"number"==typeof h?`${h}px`:h:"auto",h:x?"number"==typeof x?`${x}px`:x:"auto"})),[h,x]),[L,U,q]=(0,use_current_state/* default */.Z)(D),[v,A]=(0,use_real_shape/* default */.Z)(k),B=w&&!!h&&!!x;(0,react.useEffect)((()=>{k.current&&k.current.complete&&(F(!1),S(!1))})),(0,react.useEffect)((()=>{const t=setTimeout((()=>{B&&S(!1),clearTimeout(t)}),j);return()=>clearTimeout(t)}),[z]),(0,react.useEffect)((()=>{if(!I)return;const t=0===v.width,e="auto"===q.current;!t&&h&&x&&(v.width<h?!e&&U("auto"):e&&U(D))}),[v,h]),(0,use_resize/* default */.Z)((()=>{I&&A()}));const E=(0,react.useMemo)((()=>z?"loading":"ready"),[z]);return (0,jsx_runtime.jsxs)(StyledImageContainer,{className:(0,clsx/* default */.Z)("nextui-image-container",`nextui-image--${E}`,y),css:{width:C,height:L,...b},"data-state":E,ready:!z||R,children:[R&&(0,jsx_runtime.jsx)(image_skeleton,{opacity:1}),(0,jsx_runtime.jsx)(StyledImage,{ref:k,alt:t.alt||"",className:"nextui-image",css:{objectFit:N,...T},"data-state":E,height:x,src:g,width:h,onLoad:()=>{F(!1)},...$})]})}));assertion/* __DEV__ */.Ts&&(Image.displayName="NextUI.Image"),Image.toString=()=>".nextui-image";/* harmony default export */ var image_image = (react.memo(Image));
;// CONCATENATED MODULE: ./node_modules/@nextui-org/react/esm/image/index.js
/* harmony default export */ var esm_image = (image_image);

/***/ }),

/***/ 97501:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ZP": function() { return /* binding */ esm_loading; }
});

// UNUSED EXPORTS: Spinner, StyledLoading, StyledLoadingContainer, StyledLoadingLabel, StyledSpinner, StyledSpinnerContainer, StyledSpinnerSpan

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@nextui-org/react/esm/utils/with-defaults.js
var with_defaults = __webpack_require__(50088);
// EXTERNAL MODULE: ./node_modules/@nextui-org/react/esm/theme/stitches.config.js + 1 modules
var stitches_config = __webpack_require__(86212);
;// CONCATENATED MODULE: ./node_modules/@nextui-org/react/esm/loading/loading.styles.js
const a=(0,stitches_config/* keyframes */.F4)({"0%":{opacity:"0.2"},"20%":{opacity:1},"100%":{opacity:"0.2"}}),e=(0,stitches_config/* keyframes */.F4)({"0%":{transform:"rotate(0deg)"},"100%":{transform:"rotate(360deg)"}}),n=(0,stitches_config/* keyframes */.F4)({"0%":{transform:"translate(0px, 0px)"},"50%":{transform:"translate(0, calc(-$$loadingSize * 1.4))"},"100%":{transform:"translate(0px, 0px)"}}),t=(0,stitches_config/* keyframes */.F4)({"0%":{opacity:1},"100%":{opacity:.15}});const StyledLoadingContainer=(0,stitches_config/* styled */.zo)("div",{d:"inline-flex",fd:"column",ai:"center",position:"relative",variants:{color:{currentColor:{$$loadingColor:"currentColor"},white:{$$loadingColor:"$colors$white"},default:{$$loadingColor:"$colors$primary"},primary:{$$loadingColor:"$colors$primary"},secondary:{$$loadingColor:"$colors$secondary"},success:{$$loadingColor:"$colors$success"},warning:{$$loadingColor:"$colors$warning"},error:{$$loadingColor:"$colors$error"}},textColor:{white:{$$loadingTextColor:"$colors$white"},default:{$$loadingTextColor:"$colors$text"},primary:{$$loadingTextColor:"$colors$primary"},secondary:{$$loadingTextColor:"$colors$secondary"},success:{$$loadingTextColor:"$colors$success"},warning:{$$loadingTextColor:"$colors$warning"},error:{$$loadingTextColor:"$colors$error"}}},defaultVariants:{color:"default",textColor:"default"}});const StyledSpinnerContainer=(0,stitches_config/* styled */.zo)("div",{size:"100%",position:"relative",left:"50%",top:"50%"});const StyledSpinner=(0,stitches_config/* styled */.zo)("div",{d:"flex",fd:"column",jc:"center",ai:"center",position:"relative",variants:{size:{xs:{size:"$6"},sm:{size:"$8"},md:{size:"$9"},lg:{size:"$11"},xl:{size:"$12"}}}});const StyledSpinnerSpan=(0,stitches_config/* styled */.zo)("span",{bg:"$$loadingColor",position:"absolute",top:"-3.9%",width:"24%",height:"8%",left:"-10%",br:"$lg",animation:`${t} 1.2s linear 0s infinite normal none running`,"&:nth-child(1)":{animationDelay:"-1.2s",transform:"rotate(0deg) translate(146%)"},"&:nth-child(2)":{animationDelay:"-1.1s",transform:"rotate(30deg) translate(146%)"},"&:nth-child(3)":{animationDelay:"-1s",transform:"rotate(60deg) translate(146%)"},"&:nth-child(4)":{animationDelay:"-0.9s",transform:"rotate(90deg) translate(146%)"},"&:nth-child(5)":{animationDelay:"-0.8s",transform:"rotate(120deg) translate(146%)"},"&:nth-child(6)":{animationDelay:"-0.7s",transform:"rotate(150deg) translate(146%)"},"&:nth-child(7)":{animationDelay:"-0.6s",transform:"rotate(180deg) translate(146%)"},"&:nth-child(8)":{animationDelay:"-0.5s",transform:"rotate(210deg) translate(146%)"},"&:nth-child(9)":{animationDelay:"-0.4s",transform:"rotate(240deg) translate(146%)"},"&:nth-child(10)":{animationDelay:"-0.3s",transform:"rotate(270deg) translate(146%)"},"&:nth-child(11)":{animationDelay:"-0.2s",transform:"rotate(300deg) translate(146%)"},"&:nth-child(12)":{animationDelay:"-0.1s",transform:"rotate(330deg) translate(146%)"}});const StyledLoading=(0,stitches_config/* styled */.zo)("span",{position:"absolute",top:0,left:0,right:0,bottom:0,size:"100%",dflex:"center",bgColor:"transparent",us:"none",variants:{size:{xs:{$$loadingSize:"$space$8",$$loadingBorder:"$space$1"},sm:{$$loadingSize:"$space$10",$$loadingBorder:"$space$1"},md:{$$loadingSize:"$space$12",$$loadingBorder:"calc($space$1 * 1.5)"},lg:{$$loadingSize:"$space$15",$$loadingBorder:"$space$2"},xl:{$$loadingSize:"$space$18",$$loadingBorder:"$space$3"}},type:{default:{d:"flex",br:"$rounded",position:"relative",size:"$$loadingSize",i:{top:"0px",size:"100%",position:"absolute",br:"inherit"},"._1":{border:"$$loadingBorder solid $$loadingColor",borderTop:"$$loadingBorder solid transparent",borderLeft:"$$loadingBorder solid transparent",borderRight:"$$loadingBorder solid transparent",animation:`${e} 0.8s ease infinite`},"._2":{border:"$$loadingBorder dotted $$loadingColor",borderTop:"$$loadingBorder solid transparent",borderLeft:"$$loadingBorder solid transparent",borderRight:"$$loadingBorder solid transparent",animation:`${e} 0.8s linear infinite`,opacity:.5},"._3":{display:"none"}},points:{d:"flex",position:"relative",transform:"translate(0, calc($$loadingSize * 0.6))",i:{size:"$$loadingSize",margin:"0 3px",bg:"$$loadingColor"},"._1":{br:"$rounded",animation:`${n} 0.75s ease infinite`},"._2":{br:"$rounded",animation:`${n} 0.75s ease infinite 0.25s`},"._3":{br:"$rounded",animation:`${n} 0.75s ease infinite 0.5s`}},"points-opacity":{d:"flex",position:"relative",i:{display:"inline-block",size:"$$loadingSize",br:"$rounded",bg:"$$loadingColor",margin:"0 1px",animation:`${a} 1.4s infinite both`},"._2":{animationDelay:"0.2s"},"._3":{animationDelay:"0.4s"}},spinner:{},gradient:{display:"flex",position:"relative",size:"$$loadingSize","._1":{position:"absolute",size:"100%",border:"0px",animation:`${e} 1s linear infinite`,top:"0px",br:"$rounded",bg:"linear-gradient(0deg, $background 33%,$$loadingColor 100%)"},"._2":{top:"2px",position:"absolute",size:"calc(100% - 4px)",border:"0px",bg:"$background",br:"$rounded"},"._3":{display:"none"}}}},compoundVariants:[{size:"xs",type:"points-opacity",css:{$$loadingSize:"$space$1"}},{size:"sm",type:"points-opacity",css:{$$loadingSize:"$space$2"}},{size:"md",type:"points-opacity",css:{$$loadingSize:"$space$3"}},{size:"lg",type:"points-opacity",css:{$$loadingSize:"$space$4"}},{size:"xl",type:"points-opacity",css:{$$loadingSize:"$space$5"}},{size:"xs",type:"points",css:{$$loadingSize:"$space$1"}},{size:"sm",type:"points",css:{$$loadingSize:"$space$2"}},{size:"md",type:"points",css:{$$loadingSize:"$space$3"}},{size:"lg",type:"points",css:{$$loadingSize:"$space$4"}},{size:"xl",type:"points",css:{$$loadingSize:"$space$5"}}],defaultVariants:{type:"default"}});const StyledLoadingLabel=(0,stitches_config/* styled */.zo)("label",{mt:"$1",color:"$$loadingTextColor",fontSize:"$$loadingSize","*":{margin:0},variants:{size:{xs:{fontSize:"$space$5",marginTop:"$2"},sm:{fontSize:"$space$6",marginTop:"$3"},md:{fontSize:"$base",marginTop:"$4"},lg:{fontSize:"$space$10",marginTop:"$4"},xl:{fontSize:"$space$11",marginTop:"$5"}}}});
// EXTERNAL MODULE: ./node_modules/@nextui-org/react/esm/utils/clsx.js
var clsx = __webpack_require__(61309);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./node_modules/@nextui-org/react/esm/loading/spinner.js
const l=({children:r,size:l,color:c,textColor:m,className:p,...x})=>{const d=Array.isArray(r)?(null==r?void 0:r.length)>1&&void 0!==r[0]:void 0!==r,u=r&&d?"":"Loading";return (0,jsx_runtime.jsxs)(StyledSpinner,{className:(0,clsx/* default */.Z)("nextui-spinner",p),color:c,size:l,...x,children:[(0,jsx_runtime.jsx)(StyledSpinnerContainer,{"aria-label":u,className:"nextui-spinner-container",children:[...new Array(12)].map(((r,e)=>(0,jsx_runtime.jsx)(StyledSpinnerSpan,{},`nextui-spinner-${e}`)))}),r&&(0,jsx_runtime.jsx)(StyledLoadingLabel,{color:m,size:l,children:r})]})};l.toString=()=>".nextui-spinner";/* harmony default export */ var spinner = (l);
;// CONCATENATED MODULE: ./node_modules/@nextui-org/react/esm/loading/loading.js
const c=({children:e,size:r,gradientBackground:c,loadingCss:d,type:g,...p})=>{const u=e?"":"Loading",f=(0,react.useMemo)((()=>"gradient"===g?{"._2":{bg:c}}:{}),[g]);return (0,jsx_runtime.jsx)(StyledLoadingContainer,{...p,children:"spinner"===g?(0,jsx_runtime.jsx)(spinner,{size:r,children:e}):(0,jsx_runtime.jsxs)(jsx_runtime.Fragment,{children:[(0,jsx_runtime.jsxs)(StyledLoading,{"aria-label":u,className:`nextui-loading nextui-loading-${g}`,css:{...d,...f},size:r,type:g,children:[(0,jsx_runtime.jsx)("i",{className:"_1"}),(0,jsx_runtime.jsx)("i",{className:"_2"}),(0,jsx_runtime.jsx)("i",{className:"_3"})]}),e&&(0,jsx_runtime.jsx)(StyledLoadingLabel,{className:"nextui-loading-label",size:r,children:e})]})})};c.toString=()=>".nextui-loading";const d=react.memo(c);/* harmony default export */ var loading = ((0,with_defaults/* default */.Z)(d,{size:"md",type:"default"}));
;// CONCATENATED MODULE: ./node_modules/@nextui-org/react/esm/loading/index.js
/* harmony default export */ var esm_loading = (loading);

/***/ }),

/***/ 66391:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ esm_use_current_state; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./node_modules/@nextui-org/react/esm/use-current-state/use-current-state.js
/* harmony default export */ var use_current_state = (e=>{const[o,c]=(0,react.useState)((()=>"function"==typeof e?e():e)),u=(0,react.useRef)(e);(0,react.useEffect)((()=>{u.current=o}),[o]);return[o,t=>{const r="function"==typeof t?t(u.current):t;u.current=r,c(r)},u]});
;// CONCATENATED MODULE: ./node_modules/@nextui-org/react/esm/use-current-state/index.js
/* harmony default export */ var esm_use_current_state = (use_current_state);

/***/ }),

/***/ 35366:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ esm_use_real_shape; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./node_modules/@nextui-org/react/esm/use-real-shape/use-real-shape.js
const i=(t,e)=>{if(!t)return 0;const i=t.includes("px")?+t.split("px")[0]:t.includes("%")?+t.split("%")[0]*e*.01:t;return Number.isNaN(+i)?0:+i};const getRealShape=t=>{if(!t||"undefined"==typeof window)return{width:0,height:0};const e=t.getBoundingClientRect(),{width:h,height:n}=window.getComputedStyle(t);return{width:i(`${h}`,e.width),height:i(`${n}`,e.height)}};/* harmony default export */ var use_real_shape = (i=>{const[h,n]=(0,react.useState)({width:0,height:0}),r=()=>{const{width:t,height:e}=getRealShape(i.current);n({width:t,height:e})};return (0,react.useEffect)((()=>r()),[i.current]),[h,r]});
;// CONCATENATED MODULE: ./node_modules/@nextui-org/react/esm/use-real-shape/index.js
/* harmony default export */ var esm_use_real_shape = (use_real_shape);

/***/ }),

/***/ 36693:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ esm_use_resize; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./node_modules/@nextui-org/react/esm/use-resize/use-resize.js
/* harmony default export */ var use_resize = ((r,t=!0)=>{(0,react.useEffect)((()=>{const e=()=>r();return t&&e(),window.addEventListener("resize",e),()=>window.removeEventListener("resize",e)}),[])});
;// CONCATENATED MODULE: ./node_modules/@nextui-org/react/esm/use-resize/index.js
/* harmony default export */ var esm_use_resize = (use_resize);

/***/ }),

/***/ 48312:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(92501);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 47855:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "b": function() { return /* binding */ useLeaderboardContents; }
/* harmony export */ });
/* harmony import */ var lib_ApiRoutes__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(54591);
/* harmony import */ var lib_constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59953);
/* harmony import */ var lib_swr__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3718);
/* harmony import */ var swr__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8100);




var pollLeaderboardConfig = {
    refreshInterval: 15000
};
function useLeaderboardContents(leaderboardId) {
    return (0,swr__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)("".concat(lib_ApiRoutes__WEBPACK_IMPORTED_MODULE_0__/* .ApiRoutes.leaderboards */ .M.leaderboards, "/").concat(leaderboardId !== null && leaderboardId !== void 0 ? leaderboardId : lib_constants__WEBPACK_IMPORTED_MODULE_1__/* .DEFAULT_LEADERBOARD_ID */ ._D, "/contents"), lib_swr__WEBPACK_IMPORTED_MODULE_3__/* .defaultFetcher */ .V, pollLeaderboardConfig);
}


/***/ }),

/***/ 54591:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ ApiRoutes; }
/* harmony export */ });
var ApiRoutes;
(function(ApiRoutes) {
    ApiRoutes["leaderboards"] = "/api/leaderboards";
    ApiRoutes["tipGroups"] = "/api/tipGroups";
    ApiRoutes["admin"] = "/api/admin";
    ApiRoutes["adminTips"] = "/api/admin/tips";
    ApiRoutes["adminUsers"] = "/api/admin/users";
    ApiRoutes["tipperTips"] = "/api/tipper/tips";
    ApiRoutes["tippeeTips"] = "/api/tippee/tips";
})(ApiRoutes || (ApiRoutes = {}));


/***/ }),

/***/ 92501:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ pages; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@nextui-org/react/esm/button/index.js + 7 modules
var esm_button = __webpack_require__(27690);
// EXTERNAL MODULE: ./node_modules/@nextui-org/react/esm/loading/index.js + 3 modules
var loading = __webpack_require__(97501);
// EXTERNAL MODULE: ./node_modules/@nextui-org/react/esm/spacer/index.js + 2 modules
var spacer = __webpack_require__(28723);
// EXTERNAL MODULE: ./node_modules/@nextui-org/react/esm/text/index.js + 3 modules
var esm_text = __webpack_require__(86979);
// EXTERNAL MODULE: ./node_modules/@nextui-org/react/esm/grid/index.js + 4 modules
var grid = __webpack_require__(22553);
// EXTERNAL MODULE: ./node_modules/@nextui-org/react/esm/card/index.js + 3 modules
var card = __webpack_require__(8773);
// EXTERNAL MODULE: ./components/FlexBox.tsx
var FlexBox = __webpack_require__(54690);
// EXTERNAL MODULE: ./components/NextImage.tsx
var NextImage = __webpack_require__(44500);
// EXTERNAL MODULE: ./components/NextLink.tsx
var NextLink = __webpack_require__(45201);
// EXTERNAL MODULE: ./hooks/useLeaderboardContents.ts
var useLeaderboardContents = __webpack_require__(47855);
// EXTERNAL MODULE: ./lib/PageRoutes.ts
var PageRoutes = __webpack_require__(77137);
// EXTERNAL MODULE: ./node_modules/next-auth/react/index.js
var react = __webpack_require__(33299);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var node_modules_react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-in-viewport/dist/es/index.js
var es = __webpack_require__(19231);
;// CONCATENATED MODULE: ./node_modules/use-count-up/lib/index.module.js
var D=Object.getOwnPropertySymbols;var z=Object.prototype.hasOwnProperty,G=Object.prototype.propertyIsEnumerable;var T=(e,t)=>{var r={};for(var n in e)z.call(e,n)&&t.indexOf(n)<0&&(r[n]=e[n]);if(e!=null&&D)for(var n of D(e))t.indexOf(n)<0&&G.call(e,n)&&(r[n]=e[n]);return r};var J=Object.defineProperty,H=Object.defineProperties,K=Object.getOwnPropertyDescriptors,j=Object.getOwnPropertySymbols,Q=Object.prototype.hasOwnProperty,W=Object.prototype.propertyIsEnumerable,I=(e,t,r)=>t in e?J(e,t,{enumerable:!0,configurable:!0,writable:!0,value:r}):e[t]=r,x=(e,t)=>{for(var r in t||(t={}))Q.call(t,r)&&I(e,r,t[r]);if(j)for(var r of j(t))W.call(t,r)&&I(e,r,t[r]);return e},U=(e,t)=>H(e,K(t)),S=typeof window=="undefined"?node_modules_react.useEffect:node_modules_react.useLayoutEffect,h=({isPlaying:e,duration:t,startAt:r=0,updateInterval:n=0,onComplete:i,onUpdate:y})=>{let[p,g]=(0,node_modules_react.useState)(r),v=(0,node_modules_react.useRef)(r*-1e3),s=(0,node_modules_react.useRef)(null),m=(0,node_modules_react.useRef)(null),f=(0,node_modules_react.useRef)(null),o=(0,node_modules_react.useRef)({elapsedTimeRef:0,startAtRef:r,durationRef:t,updateIntervalRef:n});o.current=U(x({},o.current),{durationRef:t,updateIntervalRef:n});let c=a=>{let u=a/1e3;if(m.current===null){m.current=u,s.current=requestAnimationFrame(c);return}let{durationRef:l,elapsedTimeRef:F,updateIntervalRef:C,startAtRef:b}=o.current,O=u-m.current,E=F+O;m.current=u,o.current=U(x({},o.current),{elapsedTimeRef:E});let M=b+(C===0?E:(E/C|0)*C),N=b+E,A=typeof l=="number"&&N>=l;g(A?l:M),A||(s.current=requestAnimationFrame(c))},R=()=>{s.current&&cancelAnimationFrame(s.current),f.current&&clearTimeout(f.current),m.current=null},P=(0,node_modules_react.useCallback)(a=>{let u=typeof a=="number"?a:r;R(),o.current=U(x({},o.current),{elapsedTimeRef:0,startAtRef:u}),g(u),e&&(s.current=requestAnimationFrame(c))},[e,r]);return S(()=>{if(y==null||y(p),t&&p>=t){v.current+=t*1e3;let{shouldRepeat:a=!1,delay:u=0,newStartAt:l}=(i==null?void 0:i(v.current/1e3))||{};a&&(f.current=setTimeout(()=>P(l),u*1e3))}},[p,t]),S(()=>(e&&(s.current=requestAnimationFrame(c)),R),[e]),{elapsedTime:p,reset:P}};var q={easeInCubic:(e,t,r,n)=>(e/=n,r*e*e*e+t),easeOutCubic:(e,t,r,n)=>(e/=n,e--,r*(e*e*e+1)+t),linear:(e,t,r,n)=>r*e/n+t},V=q.easeOutCubic,L=e=>typeof e=="function"?e:q[e];var ee=(e,t)=>{if(typeof e=="number")return typeof t=="number"?t:2},$=(e,t)=>e.replace(/\B(?=(\d{3})+(?!\d))/g,t),k=e=>(e.toString().split(".")[1]||"").length,te=(e,t)=>{let r=k(e),n=k(t||1);return r>=n?r:n},w=({isCounting:e=!1,start:t=0,end:r,duration:n,decimalPlaces:i=te(t,r),decimalSeparator:y=".",thousandsSeparator:p="",onComplete:g,easing:v=V,formatter:s,updateInterval:m,onUpdate:f})=>{let o=ee(r,n),c=a=>{let u;if(o===0&&typeof r=="number")u=r;else if(typeof r=="number"&&typeof o=="number"){let b=L(v),O=a<o?a:o;u=b(O,t,r-t,o)}else u=t+a;if(typeof s=="function")return s(u);if(i===0){let b=Math.round(u).toString();return $(b,p)}let[l,F]=u.toFixed(i).split(".");return`${$(l,p)}${y}${F}`},{elapsedTime:R,reset:P}=h({isPlaying:e,duration:o,onComplete:g,updateInterval:m,onUpdate:typeof f=="function"?a=>f(c(a)):void 0});return{value:c(R),reset:P}};var B=r=>{var n=r,{children:e}=n,t=T(n,["children"]);let i=w(t);return typeof e=="function"?e(i):i.value};B.displayName="CountUp";

;// CONCATENATED MODULE: ./pages/index.tsx














var Home = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                    children: "⚡SVRN Energy⚡"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Homepage, {})
        ]
    });
};
/* harmony default export */ var pages = (Home);
function HomepageCTA() {
    var ref = (0,react.useSession)(), sessionStatus = ref.status;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(NextLink/* NextLink */.p, {
        href: sessionStatus === "authenticated" ? PageRoutes/* PageRoutes.dashboard */.d.dashboard : PageRoutes/* PageRoutes.signin */.d.signin,
        passHref: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_button/* default */.ZP, {
                color: "primary",
                size: "lg",
                children: sessionStatus === "authenticated" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: "Open dashboard"
                }) : sessionStatus === "unauthenticated" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: "Claim Rewards \xbb"
                }) : ""
            })
        })
    });
}
function Homepage() {
    var ref = (0,useLeaderboardContents/* useLeaderboardContents */.b)(), leaderboardContents = ref.data;
    var ref1 = (0,_sliced_to_array/* default */.Z)(node_modules_react.useState(false), 2), pageLoaded = ref1[0], setPageLoaded = ref1[1];
    var ref2 = (0,react.useSession)(), sessionStatus = ref2.status;
    var router = (0,next_router.useRouter)();
    var token = router.query.token;
    node_modules_react.useEffect(function() {
        var onPageLoad = function() {
            setPageLoaded(true);
        };
        if (document.readyState === "complete") {
            onPageLoad();
        } else {
            window.addEventListener("load", onPageLoad);
            return function() {
                return window.removeEventListener("load", onPageLoad);
            };
        }
    }, []);
    node_modules_react.useEffect(function() {
        if (sessionStatus === "authenticated") {
            router.push(PageRoutes/* PageRoutes.dashboard */.d.dashboard);
        }
    }, [
        router,
        sessionStatus
    ]);
    node_modules_react.useEffect(function() {
        if (token) {
            // breez jwt token
            router.replace("".concat(PageRoutes/* PageRoutes.verifySignin */.d.verifySignin, "/").concat(token));
        }
    }, [
        router,
        token
    ]);
    if (!router || !router.isReady || token || !pageLoaded) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(FlexBox/* FlexBox */.h, {
            style: {
                height: "100%",
                justifyContent: "center"
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(loading/* default */.ZP, {})
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(spacer/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(NextImage/* NextImage */.o, {
                alt: "",
                src: "/images/SVRN_3_Cans_small.png",
                width: 550,
                height: 550
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(spacer/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_text/* default */.Z, {
                h1: true,
                css: {
                    textGradient: "45deg, #ff9400 -20%, #ffcf00 50%",
                    lineHeight: 1.2,
                    textAlign: "center"
                },
                children: "Are you thirsty for sats?"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_text/* default */.Z, {
                h1: true,
                size: "$4xl",
                children: "Join the Bitcoin Revolution."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(spacer/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HomepageCTA, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(spacer/* default */.Z, {
                y: 5
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(grid/* default.Container */.ZP.Container, {
                sm: 10,
                justify: "center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(card/* default */.ZP, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(card/* default.Body */.ZP.Body, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(grid/* default.Container */.ZP.Container, {
                            gap: 2,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(grid/* default */.ZP, {
                                    sm: 12,
                                    md: 4,
                                    css: {
                                        fg: 1,
                                        jc: "flex-start",
                                        ai: "center",
                                        flexDirection: "column",
                                        ta: "center"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(NextImage/* NextImage */.o, {
                                            alt: "",
                                            src: "/images/gift.png",
                                            width: 128,
                                            height: 128
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_text/* default */.Z, {
                                            h3: true,
                                            children: "Eat. Drink. Sats."
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_text/* default */.Z, {
                                            color: "$gray700",
                                            children: "If your tippee doesn't claim their tip, those precious sats return to you."
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(grid/* default */.ZP, {
                                    sm: 12,
                                    md: 4,
                                    css: {
                                        jc: "flex-start",
                                        ai: "center",
                                        flexDirection: "column",
                                        ta: "center",
                                        fg: 1
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(NextImage/* NextImage */.o, {
                                            alt: "",
                                            src: "/images/flag.png",
                                            width: 128,
                                            height: 128
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_text/* default */.Z, {
                                            h3: true,
                                            children: "Progress tracker"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_text/* default */.Z, {
                                            color: "$gray700",
                                            children: "Follow SVRN into the Bitcoin rabbit hole."
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(grid/* default */.ZP, {
                                    sm: 12,
                                    md: 4,
                                    css: {
                                        jc: "flex-start",
                                        ai: "center",
                                        flexDirection: "column",
                                        ta: "center",
                                        fg: 1
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(NextImage/* NextImage */.o, {
                                            alt: "",
                                            src: "/images/onboarding.png",
                                            width: 128,
                                            height: 128
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_text/* default */.Z, {
                                            h3: true,
                                            children: "Onboarding you to Bitcoin"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_text/* default */.Z, {
                                            color: "$gray700",
                                            children: "SVRN Energy will help onboard you to Bitcoin and install your own wallet to withdraw Bitcoin."
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(spacer/* default */.Z, {
                y: 5
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_text/* default */.Z, {
                h1: true,
                size: "$8xl",
                css: {
                    textGradient: "45deg, #ff9400 -20%, #ffcf00 50%",
                    lineHeight: 1.2,
                    textAlign: "center"
                },
                children: "Join the Bitcoin revolution."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HomepageCTA, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(spacer/* default */.Z, {
                y: 5
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_text/* default */.Z, {
                h3: true,
                style: {
                    textAlign: "center"
                },
                children: "Learn More"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(spacer/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(NextLink/* NextLink */.p, {
                href: PageRoutes/* PageRoutes.about */.d.about,
                passHref: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_button/* default */.ZP, {
                        color: "primary",
                        size: "lg",
                        children: "About"
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(spacer/* default */.Z, {
                y: 4
            })
        ]
    });
}
function TipCounter(param) {
    var totalSatsSent = param.totalSatsSent;
    var myRef = useRef(null);
    var inViewport = useInViewport(myRef, {}, {
        disconnectOnLeave: false
    }).inViewport;
    return /*#__PURE__*/ _jsxs("div", {
        style: {
            textAlign: "center"
        },
        children: [
            /*#__PURE__*/ _jsx(Text, {
                h3: true,
                children: "With SVRN Energy"
            }),
            /*#__PURE__*/ _jsx(Spacer, {
                y: 0.5
            }),
            /*#__PURE__*/ _jsxs(Text, {
                b: true,
                ref: myRef,
                css: {
                    textGradient: "45deg, #ff9400 -20%, #ffcf00 50%",
                    lineHeight: "$xs",
                    mt: -10,
                    fontSize: "$4xl",
                    "@lg": {
                        fontSize: "$8xl"
                    }
                },
                children: [
                    inViewport ? /*#__PURE__*/ _jsx(CountUp, {
                        isCounting: true,
                        end: totalSatsSent,
                        easing: "easeOutCubic",
                        duration: 2,
                        thousandsSeparator: ","
                    }) : 0,
                    "\xa0sats"
                ]
            }),
            /*#__PURE__*/ _jsx(Spacer, {}),
            /*#__PURE__*/ _jsx(Text, {
                h3: true,
                children: "have been energized to date."
            })
        ]
    });
}


/***/ }),

/***/ 19231:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


__webpack_unused_export__ = true;
exports.NM = __webpack_unused_export__ = __webpack_unused_export__ = __webpack_unused_export__ = void 0;

var _handleViewport = _interopRequireDefault(__webpack_require__(77095));

__webpack_unused_export__ = _handleViewport.default;

var _useInViewport = _interopRequireDefault(__webpack_require__(32659));

exports.NM = _useInViewport.default;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var customProps = ['inViewport', 'enterCount', 'leaveCount'];
__webpack_unused_export__ = customProps;
var _default = _handleViewport.default;
__webpack_unused_export__ = _default;

/***/ }),

/***/ 61319:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


exports.__esModule = true;
exports.noop = exports.defaultProps = exports.defaultOptions = exports.defaultConfig = void 0;
var defaultOptions = {};
exports.defaultOptions = defaultOptions;
var defaultConfig = {
  disconnectOnLeave: false
};
exports.defaultConfig = defaultConfig;

var noop = () => {};

exports.noop = noop;
var defaultProps = {
  onEnterViewport: noop,
  onLeaveViewport: noop
};
exports.defaultProps = defaultProps;

/***/ }),

/***/ 77095:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports["default"] = void 0;

var _react = __webpack_require__(67294);

var _hoistNonReactStatics = _interopRequireDefault(__webpack_require__(8679));

var _useInViewport = _interopRequireDefault(__webpack_require__(32659));

var _constants = __webpack_require__(61319);

var _jsxRuntime = __webpack_require__(85893);

var _excluded = ["onEnterViewport", "onLeaveViewport"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var isFunctionalComponent = Component => {
  return typeof Component === 'function' && !(Component.prototype && Component.prototype.render);
};

var isReactComponent = Component => {
  return Component.prototype && Component.prototype.isReactComponent;
};

function handleViewport(TargetComponent, options, config) {
  if (options === void 0) {
    options = _constants.defaultOptions;
  }

  if (config === void 0) {
    config = _constants.defaultConfig;
  }

  var ForwardedRefComponent = /*#__PURE__*/(0, _react.forwardRef)((props, ref) => {
    var refProps = _extends({
      forwardedRef: ref
    }, isReactComponent(TargetComponent) && !isFunctionalComponent(TargetComponent) ? {
      ref
    } : {});

    return /*#__PURE__*/(0, _jsxRuntime.jsx)(TargetComponent, _extends({}, props, refProps));
  });

  function InViewport(_ref) {
    var {
      onEnterViewport = _constants.noop,
      onLeaveViewport = _constants.noop
    } = _ref,
        restProps = _objectWithoutPropertiesLoose(_ref, _excluded);

    var node = (0, _react.useRef)();
    var {
      inViewport,
      enterCount,
      leaveCount
    } = (0, _useInViewport.default)(node, options, config, {
      onEnterViewport,
      onLeaveViewport
    });
    var injectedProps = {
      inViewport,
      enterCount,
      leaveCount
    };
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(ForwardedRefComponent, _extends({}, restProps, injectedProps, {
      ref: node
    }));
  }

  var name = TargetComponent.displayName || TargetComponent.name || 'Component';
  InViewport.displayName = "handleViewport(" + name + ")";
  return (0, _hoistNonReactStatics.default)(InViewport, ForwardedRefComponent);
}

var _default = handleViewport;
exports["default"] = _default;

/***/ }),

/***/ 32659:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports["default"] = void 0;

var _react = __webpack_require__(67294);

var _reactDom = __webpack_require__(73935);

var _constants = __webpack_require__(61319);

var useInViewport = function useInViewport(target, options, config, props) {
  if (options === void 0) {
    options = _constants.defaultOptions;
  }

  if (config === void 0) {
    config = _constants.defaultConfig;
  }

  if (props === void 0) {
    props = _constants.defaultProps;
  }

  var {
    onEnterViewport,
    onLeaveViewport
  } = props;
  var [, forceUpdate] = (0, _react.useState)();
  var observer = (0, _react.useRef)();
  var inViewportRef = (0, _react.useRef)(false);
  var intersected = (0, _react.useRef)(false);
  var enterCountRef = (0, _react.useRef)(0);
  var leaveCountRef = (0, _react.useRef)(0);

  function startObserver(_ref) {
    var {
      observerRef
    } = _ref;
    var targetRef = target.current;

    if (targetRef) {
      var node = (0, _reactDom.findDOMNode)(targetRef);

      if (node) {
        observerRef == null ? void 0 : observerRef.observe(node);
      }
    }
  }

  function stopObserver(_ref2) {
    var {
      observerRef
    } = _ref2;
    var targetRef = target.current;

    if (targetRef) {
      var node = (0, _reactDom.findDOMNode)(targetRef);

      if (node) {
        observerRef == null ? void 0 : observerRef.unobserve(node);
      }
    }

    observerRef == null ? void 0 : observerRef.disconnect();
    observer.current = null;
  }

  function handleIntersection(entries) {
    var entry = entries[0] || {};
    var {
      isIntersecting,
      intersectionRatio
    } = entry;
    var isInViewport = typeof isIntersecting !== 'undefined' ? isIntersecting : intersectionRatio > 0; // enter

    if (!intersected.current && isInViewport) {
      intersected.current = true;
      onEnterViewport == null ? void 0 : onEnterViewport();
      enterCountRef.current += 1;
      inViewportRef.current = isInViewport;
      forceUpdate(isInViewport);
      return;
    } // leave


    if (intersected.current && !isInViewport) {
      intersected.current = false;
      onLeaveViewport == null ? void 0 : onLeaveViewport();

      if (config.disconnectOnLeave && observer.current) {
        // disconnect obsever on leave
        observer.current.disconnect();
      }

      leaveCountRef.current += 1;
      inViewportRef.current = isInViewport;
      forceUpdate(isInViewport);
    }
  }

  function initIntersectionObserver(_ref3) {
    var {
      observerRef
    } = _ref3;

    if (!observerRef) {
      observer.current = new IntersectionObserver(handleIntersection, options);
      return observer.current;
    }

    return observerRef;
  }

  (0, _react.useEffect)(() => {
    var observerRef = observer.current; // https://developer.mozilla.org/en-US/docs/Web/API/Intersection_Observer_API

    observerRef = initIntersectionObserver({
      observerRef
    });
    startObserver({
      observerRef
    });
    return () => {
      stopObserver({
        observerRef
      });
    };
  }, [target.current, options, config, onEnterViewport, onLeaveViewport]);
  return {
    inViewport: inViewportRef.current,
    enterCount: enterCountRef.current,
    leaveCount: leaveCountRef.current
  };
};

var _default = useInViewport;
exports["default"] = _default;

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(48312); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);